import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../images/search_icon.png'



export default /*@__PURE__*/_defineComponent({
  __name: 'search_bar',
  props: {
    "value": {
    default: null,
    required: true,
    type: String
  },
    "valueModifiers": {},
  },
  emits: /*@__PURE__*/_mergeModels(["update"], ["update:value"]),
  setup(__props, { emit: __emit }) {

  const emits = __emit
  const value = _useModel(__props, "value")

return (_ctx: any,_cache: any) => {
  const _component_scoped = _resolveComponent("scoped")!

  return (_openBlock(), _createBlock(_component_scoped, null, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        onKeyup: _cache[2] || (_cache[2] = _withKeys(($event: any) => (emits('update')), ["enter"]))
      }, [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('update')))
        }, [...(_cache[3] || (_cache[3] = [
          _createElementVNode("img", {
            alt: "Search",
            src: _imports_0
          }, null, -1)
        ]))]),
        _withDirectives(_createElementVNode("input", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((value).value = $event)),
          type: "text"
        }, null, 512), [
          [_vModelText, value.value]
        ])
      ], 32)
    ]),
    _: 1
  }))
}
}

})